export default __webpack_public_path__ + "static/mamasquare_logo-2dfae29ce6ae9faee27a800c0755e388.jpg";